import { groupSchema, type Group } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import groups to the global cache from a list of groups.
 *
 * @param groups - array of Groups
 */
function importGroups(groups: Group[]) {
  const parsedResult = filteredArray(groupSchema).safeParse(groups);
  if (parsedResult.success) {
    importEntities(QueryKeys.groups.global, parsedResult.data);
  }
}

export { importGroups };
